import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/MasterData/SubContractor/add'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { v3_add_sub_contractor } from '../../../actions/v3/masterData'
const Add = (props) => {

    const onSubmit = (model) => {
        v3_add_sub_contractor(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listSubContractorMasterData.url)
            }
            else {
                toast.error(res.error)

            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Add Ship Type'}
            >
                <Form
                    title={'Add Ship Type'}
                    onSubmit={onSubmit}
                    buttonName={'Create Ship Type'}
                />
            </Layout>
        </React.Fragment>
    )
}

export default Add